// extracted by mini-css-extract-plugin
export default {"Card":"m9KJt8b2pwE9YPljpqu2","card":"oAp9Z_NvRYVGyEt2kSry"};